import React, {ChangeEvent} from 'react';

import {EventDescriptionGenerationController, EventReviewFeedback} from 'src/modules/ai';
import {TourAnchor} from 'src/modules/ai/tour/tour-anchor';
import {EventCreationMode, HeaderFields} from 'src/modules/event-create/constants';
import {EVENT_DESCRIPTION_INFO} from 'src/modules/event-create/event-create-hovers';
import {HeaderBlock} from 'src/modules/event-create/typedefs';
import {capitalizeFirstLetter} from 'src/modules/event-create/utils/capitalizeFirstLetter';
import {
    MAX_LENGTH_DESCRIPTION,
    eventDescriptionValidation,
} from 'src/modules/event-create/validations/event-description-validation';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';

import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {InfoIconButton} from '@pb/kit-component-icon-button';
import {Input} from '@pb/kit-component-input-v2';

type Props = {
    headerValues: HeaderBlock,
    mode: EventCreationMode,
    eventChangeRequest: EventChangeRequest,
    changeRequestId: number | null,
    validationHighLight: boolean,
    onInputBlur: (event: React.FocusEvent<HTMLInputElement>, name?: string) => void,
    onChangeField: (value: string, name?: string) => void,
};

export const EventDescription = (props: Props) => {
    const {
        headerValues,
        mode,
        eventChangeRequest,
        changeRequestId,
        validationHighLight,
        onInputBlur,
        onChangeField,
    } = props;

    const onEventDescriptionGenerate = (description: string) => {
        onChangeField(description, HeaderFields.eventDescription);
    };

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChangeField(event.target.value, HeaderFields.eventDescription);
    };

    const hasValidationError = Boolean(validationHighLight &&
        eventDescriptionValidation(headerValues.description).length);

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group gap="xs" alignItems="center" justify="start">
                <strong>Event Description:</strong>
                <Dropdown
                    hoverEnabled={true}
                    clickEnabled={false}
                    maxWidth={500}
                    maxHeight={600}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                    )}>
                    {EVENT_DESCRIPTION_INFO}
                </Dropdown>
                {mode === EventCreationMode.create && (
                    <>
                        <TourAnchor className="ai-feedback-tour" icon={Icons.CHAT}/>
                        <EventReviewFeedback
                            changeRequestId={changeRequestId}
                            fieldName={HeaderFields.eventDescription}
                        />
                    </>
                )}
            </Group>
            <Group>
                <Item style={{width: '100%'}}>
                    <Input
                        name={HeaderFields.eventDescription}
                        className="ellipsis"
                        placeholder="Event Description"
                        autoComplete="off"
                        color={hasValidationError ? 'ERROR' : 'DEFAULT'}
                        value={mode === EventCreationMode.create ?
                                capitalizeFirstLetter(headerValues.description) : headerValues.description}
                        maxLength={MAX_LENGTH_DESCRIPTION}
                        onBlur={onInputBlur}
                        onChange={onChange}
                        endAdornment={mode === EventCreationMode.create && (
                            <EventDescriptionGenerationController
                                eventChangeRequest={eventChangeRequest}
                                onEventDescriptionGenerate={onEventDescriptionGenerate}
                            />
                        )}
                    />
                </Item>
                <Item style={{width: '1rem'}}><span/></Item>
            </Group>
        </Group>
    );
};
